angular.module('AccountingBoxApp')
  .filter('dateFilter', function ($filter) {
        return function (array, config) {

           // console.log('config',config);
            if (config === undefined || config.field === undefined || config.format === undefined || config.property === undefined)
                return array;
        
            var filtered = [];
            angular.forEach(array, function (item,index) {
                             array[index].formatedDate = [];
              //  console.log('item:',item);
                //console.log(getPropByString(item, config.property));
                //if ($filter('date')(new Date(getPropByString(item, config.property)), config.format).indexOf(config.field) > -1)
                    //filtered.push(item);
                    var nl = moment.defineLocale('nl', {
        calendar : {
            sameDay: '[vandaag]',
            nextDay: '[morgen]',
            nextWeek: 'dddd',
            lastDay: '[gisteren]',
            lastWeek: '[afgelopen] dddd',
            sameElse: 'L'
        }});
                array[index].formatedDate.push(moment(getPropByString(item, config.property)).locale('nl').format('L'));
                array[index].formatedDate.push(moment(getPropByString(item, config.property)).locale('nl').format('LL'));
                array[index].formatedDate.push(moment(getPropByString(item, config.property)).locale('nl').format('dddd LL'));
                array[index].formatedDate.push(moment(getPropByString(item, config.property)).locale('nl').fromNow());
                array[index].formatedDate.push(moment(getPropByString(item, config.property)).locale('nl').calendar());

//console.log('array formated dates:',array[index].formatedDate);
                //  array[index].formatedDate.push($filter('date')(new Date(getPropByString(item, config.property)), config.format)); 
                 // array[index].formatedDate.push($filter('date')(new Date(getPropByString(item, config.property)), config.format)); 
                  //array[index].formatedDate.push($filter('date')(new Date(getPropByString(item, config.property)), config.format)); 

            });

            return array;
        };

        function getPropByString(obj, propertyString) {
            if (!propertyString)
                return obj;

            var property, properties = propertyString.split('.');

            for (var i = 0, iLen = properties.length - 1; i < iLen; i++) {
                property = properties[i];

                var candidate = obj[property];
                if (candidate !== undefined) {
                    obj = candidate;
                } else {
                    break;
                }
            }
            return obj[properties[i]];
        }
    });